import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import ColorGradientControl from '../colors-gradients/control';
export default function ColorPaletteControl(_ref) {
  let {
    onChange,
    value,
    ...otherProps
  } = _ref;
  return createElement(ColorGradientControl, _extends({}, otherProps, {
    onColorChange: onChange,
    colorValue: value,
    gradients: [],
    disableCustomGradients: true
  }));
}
//# sourceMappingURL=control.js.map